export const countSelectedAttachments = (files) => {
  if (!Array.isArray(files)) return 0;

  return files.reduce((total, item) => {
    const parentSelected = item?.parent?.isActive ? 1 : 0;
    const versionsSelected = Array.isArray(item?.version)
      ? item.version.filter((version) => version?.isActive).length
      : 0;

    return total + parentSelected + versionsSelected;
  }, 0);
};
